/* import __COLOCATED_TEMPLATE__ from './date-input.hbs'; */
import { action, computed } from '@ember/object';
import { dateFormat } from 'client-portal/utils/date-time';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';
import moment from 'moment-timezone';

@classic
export default class SharedDateInput extends Component {
  inactivePlaceholder = dateFormat.toLowerCase();

  @computed('_inputValue', 'value')
  get formattedValue() {
    let formatted = this.value?.isValid?.() ? this.value.format(dateFormat) : null;

    // Prefer the typed buffer only while it matches the current value (or the
    // value isn't parseable yet); a stale buffer would hide external changes.
    if (this._inputValue && (!formatted || this._inputValue === formatted)) {
      return this._inputValue;
    }

    if (formatted) {
      return formatted;
    }

    return this.value?.format ? this.value.format(dateFormat) : null;
  }

  @action
  setText(text) {
    this.set('_inputValue', text);
    let date = text ? moment(text, dateFormat, true) : null;
    this.onSetText(date);
  }
}
